import api from './api';
import { handleError } from '../utils/errorHandler';
import { logger } from '../utils/logger';

const TOKEN_KEY = 'token';
const REFRESH_KEY = 'refreshToken';

export const authService = {
  login: async (email: string, password: string) => {
    try {
      const response = await api.post('/token/', { email, password });

      if (response.data.access) {
        localStorage.setItem(TOKEN_KEY, response.data.access);
        localStorage.setItem(REFRESH_KEY, response.data.refresh);
      }

      return response.data;
    } catch (error) {
      const apiError = handleError(error, 'ao realizar login');
      throw new Error(apiError.message);
    }
  },

  logout: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(REFRESH_KEY);
    logger.info('Usuário deslogado');
  },

  refreshToken: async () => {
    // Mantido para compatibilidade, mas não é mais necessário
    // O refresh é tratado automaticamente pelo interceptor do axios
    return null;
  }
};

export const fetchCurrentUser = async () => {
  try {
    const response = await api.get('core/me/');
    return response.data;
  } catch (error) {
    handleError(error, 'ao buscar perfil do usuário');
    throw error;
  }
};
